import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'types/RootState';

// Base selector to get the comment state
export const selectComment = (state: RootState) => state.comment;

// Memoized selectors using createSelector for performance
export const selectCardData = createSelector(
  [selectComment],
  comment => comment?.cardData
);

export const selectSelectedFilter = createSelector(
  [selectComment],
  comment => comment?.selectedFilter || null
);

export const selectFilterOptions = createSelector(
  [selectComment],
  comment => comment?.filterOptions || []
);

export const selectIsLoadingFilterOptions = createSelector(
  [selectComment],
  comment => comment?.isLoadingFilterOptions || false
);

export const selectSelectedSection = createSelector(
  [selectComment],
  comment => comment?.selectedSection || null
);

export const selectSectionOptions = createSelector(
  [selectComment],
  comment => comment?.sectionOptions || []
);

export const selectIsLoading = createSelector(
  [selectComment],
  comment => comment?.isLoading || false
);

export const selectError = createSelector(
  [selectComment],
  comment => comment?.error || null
);

export const selectComments = createSelector(
  [selectComment],
  comment => comment?.comments || []
);

export const selectApiResponseStatus = createSelector(
  [selectComment],
  comment => comment?.apiResponseStatus || { status: null, message: null }
);

export const selectBadgeCount = createSelector(
  [selectComment],
  comment => comment?.badgeCount || 0
);

export const selectCurrentCommentId = createSelector(
  [selectComment],
  comment => comment?.currentCommentId ?? null
);

export const selectCommunicationMode = createSelector(
  [selectComment],
  comment => comment?.communicationMode ?? 'EMAIL'
);
